import { defineMessages } from 'react-intl';

export default defineMessages({
	requests: {
		defaultMessage: 'Requests',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user requests section.',
		id: 'avatar.menu.v2.header.requests',
	},
	requestListHeading: {
		defaultMessage: 'REQUESTS LIST',
		description: 'Requests list header in menu request subsection',
		id: 'avatar.menu.v2.header.requests-list',
	},
	customizeRequestList: {
		defaultMessage: 'Manage columns',
		description: 'Manage columns item in menu request subsection',
		id: 'avatar.menu.v2.header.manage-column',
	},
	approvals: {
		defaultMessage: 'Approvals',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user approvals section.',
		id: 'avatar.menu.v2.header.approvals',
	},
	profile: {
		defaultMessage: 'Profile',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user profile page.',
		id: 'avatar.menu.v2.header.profile',
	},
	logout: {
		defaultMessage: 'Log out',
		description:
			'The text is shown on the log out button in the avatar drop-down menu that signs the user out of their account.',
		id: 'avatar.menu.v2.logout',
	},
	pageLayout: {
		defaultMessage: 'Page layout',
		description: 'Topics and Portals in avatar drop-down menu',
		id: 'avatar.menu.v2.topic',
	},
	beta: {
		defaultMessage: 'Beta',
		description: 'Beta lozenge for flexi HC in avatar drop-down menu',
		id: 'avatar.menu.v2.label.beta',
	},
	newLozenge: {
		defaultMessage: 'New',
		description: 'BeNewta lozenge in avatar drop-down menu',
		id: 'avatar.menu.v2.label.newLozenge',
	},
	topicsAndPortals: {
		defaultMessage: 'Topics and portals',
		description: 'Topics and Portals in avatar drop-down menu when advanced customization enabled',
		id: 'avatar.menu.v2.topics.and.portals',
	},
	look: {
		defaultMessage: 'Look and feel',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the look and feel customization settings.',
		id: 'avatar.menu.v2.look',
	},
	announcement: {
		defaultMessage: 'Announcements',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the announcements settings page.',
		id: 'avatar.menu.v2.announcement',
	},
	signIn: {
		defaultMessage: 'Log in message',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the log in message customization settings.',
		id: 'avatar.menu.v2.signIn',
	},
	helpCenterSettings: {
		defaultMessage: 'Service hub settings',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the service hub settings page.',
		id: 'avatar.menu.v2.helpCenterSettings',
	},
	customerHubSettings: {
		defaultMessage: 'Customer experience settings',
		description: 'Customer experience settings navigation item',
		id: 'avatar.menu.v2.customerHubSettings',
	},
	tooltip: {
		defaultMessage: 'Profile and settings',
		description:
			'The text is shown as a tooltip when the user hovers over the avatar icon, indicating it opens the profile and settings menu.',
		id: 'avatar.profile.v2.tooltip',
	},
	reporting: {
		defaultMessage: 'Performance',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the Performance reporting page.',
		id: 'avatar.menu.v2.reporting',
	},
	virtualServiceAgent: {
		defaultMessage: 'Virtual service agent',
		description:
			'The text is shown as a navigation menu item in the avatar drop-down menu that links to the virtual service agent configuration page.',
		id: 'avatar.menu.v2.virtualServiceAgent',
	},
	portalAnnouncement: {
		defaultMessage: 'Announcements',
		description: 'announcement item in menu portal subsection',
		id: 'avatar.menu.v2.portalAnnouncement',
	},
	portalRequestTypeGroup: {
		defaultMessage: 'Portal groups',
		description: 'portal groups item in menu portal subsection',
		id: 'avatar.menu.v2.requestTypeGroup',
	},
	portal: {
		defaultMessage: 'PORTAL',
		description: 'Portal heading for menu portal subsection',
		id: 'avatar.menu.v2.portal.section',
	},
	helpCenter: {
		defaultMessage: 'HELP CENTER',
		description: 'Help Center heading for menu multi hc subsection',
		id: 'avatar.menu.v2.helpCenter.section',
	},
	onboardingDescriptionCreateOrHcClickWithLink: {
		defaultMessage:
			'Upgrade to Jira Service Management Premium to create and manage multiple help centers on your site and ',
		description:
			'Upgrade modal description a help center is clicked or create a help center is clicked',
		id: 'uh.home.downgrade.modal.description.create.or.hc.with.link',
	},
	// eslint-disable-next-line rulesdir/i18n-unique-message-ids
	onboardingTitleHCClick: {
		defaultMessage: 'Serve different audiences with multiple help centers',
		description: 'Upgrade modal title when help center is clicked',
		id: 'uh.home.downgrade.modal.title.hc',
	},
	freeStandardAdminsChangeBoardingHeading: {
		defaultMessage: 'Your help center settings have moved here',
		description: 'Heading text for Free Standard Admins Change Boarding',
		id: 'sd.topic.filter.free.and.standard.changeboarding.heading',
	},
	freeStandardAdminsChangeBoardingContent: {
		defaultMessage:
			'Manage profile settings, view your requests, and customize your help center from here.',
		description: 'Content for topics Free Standard Admins Change Boarding',
		id: 'sd.topic.filter.free.and.standard.changeboarding.content',
	},
	freeStandardAdminsChangeBoardingButton: {
		defaultMessage: 'OK',
		description: 'Button text for Free Standard Admins Change Boarding',
		id: 'sd.topic.filter.free.and.standard.changeboarding.button',
	},
	singlePortalScreenAdminsChangeBoardingHeading: {
		defaultMessage: 'Your portal settings have moved here',
		description: 'Heading text for Single Portal Screen Admins Change Boarding',
		id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.heading.',
	},
	singlePortalScreenAdminsChangeBoardingContent: {
		defaultMessage:
			'Access your requests, profile settings, and customize the portal experience from here',
		description: 'Content for topics Single Portal Screen Admins Change Boarding',
		id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.content',
	},
	singlePortalScreenAdminsChangeBoardingButton: {
		defaultMessage: 'OK',
		description: 'Button text for Single Portal Screen Admins Change Boarding',
		id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.button',
	},
	manageHc: {
		defaultMessage: 'View all help centers',
		description: 'Message for navigating to hc-management screen in avatar menu',
		id: 'avatar.menu.v2.manageHc',
	},
	managePages: {
		defaultMessage: 'Landing pages',
		description: 'Message for navigating to landing pages screen in avatar menu',
		id: 'avatar.menu.v2.help.center.pages',
	},
	rovoAgent: {
		defaultMessage: 'Rovo Agent',
		description:
			'Label for create cutomized rovo agent button in avatar menue which is used to create a customized rovo agent',
		id: 'avatar.menu.v2.rovoAgent',
	},
	createHc: {
		defaultMessage: 'Create a help center',
		description:
			'Label for create help center button in avatar menu which is used to navigate to the help center management page',
		id: 'avatar.menu.v2.createHc',
	},
	pageLayoutPremiumDescription: {
		defaultMessage:
			'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
		description: 'Description for premium suggestion of feature Page Layout',
		id: 'avatar.menu.v2.pageLayout.premium.description',
	},
	pageLayoutTryItNowButton: {
		defaultMessage: 'Try it now',
		description: 'Button to try the premium feature Page Layout',
		id: 'avatar.menu.v2.pageLayout.premium.try.it.now.button',
	},
	premiumLozenge: {
		defaultMessage: 'Premium',
		description: 'Premium lozenge in avatar drop-down menu',
		id: 'avatar.menu.v2.label.premium.lozenge',
	},
	landingPagesNonPremiumDescription: {
		defaultMessage:
			'You need to be on a Premium or Enterprise plan to create landing pages in a help center.',
		description: 'Non premium description for landing pages',
		id: 'avatar.menu.v2.landing.pages.non.premium.customer.description',
	},
	helpCenterMenuOptions: {
		defaultMessage: 'Help center menu options',
		description: 'Aria label for help center menu navigation list',
		id: 'avatar.menu.v2.helpCenter.menu.options',
	},
});
